{{ name }} is
<span class="status"
      [class.valid]="validity">
                        {{ validity ? 'valid' : 'invalid' }}</span>
with value {{ determineValue() }}
